const generateCategoryColor = (category) => {
  switch (category) {
    case 'compliance':
      return '#24BEA2';
    case 'hiring':
      return '#B91600';
    case 'legal':
      return '#61BD23';
    case 'payroll':
      return '#EBD403';
    case 'privacy':
      return '#F3A93C';
    case 'remote-work':
      return '#2D76F6';
    case 'time-off':
      return '#9E23BD';
    case 'tools-resources':
      return '#E66E61';
    case 'company-news':
      return '#9E23BD';
    default:
      return '#2D46C1';
  }
};

export default generateCategoryColor;
